import React from "react";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";

const PaymentTerms = () => {
  ChangeTitle("Payment Terms");

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              Payment terms
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="">
            <div className="mb-[2rem]">
              <p className="legal-text-fs legal-text-b">Placing An Order</p>
              <p className="legal-para">
                You can place an order through our website.
              </p>
            </div>
            <div className="mb-[2rem]">
              <p className="legal-text-fs legal-text-b">Order Confirmation</p>
              <p className="legal-para">
                You will receive a confirmation of your order by email.
              </p>
            </div>
            <div className="mb-[2rem]">
              <p className="legal-text-fs legal-text-b">Payment</p>
              <p className="legal-para">
                Payment must be made using UPI, Debit Card, Credit Card, Bank
                Transfer, Demand Draft, or cheque.
              </p>
            </div>
            <div className="mb-[2rem]">
              <p className="legal-text-fs legal-text-b">
                Bank Transfer, Cheque payment, or Demand Draft
              </p>
              <p className="legal-para">
                If you have chosen this payment option, please scan the order
                form you receive at the last step of placing an order. Email the
                same with the Cheque / Demand Draft to
              </p>
            </div>
            <a
              href="#"
              className="mb-[2rem] underline legal-text-fs legal-text-y"
            >
              gcchelplaw@gmail.com
            </a>
            <p className="legal-para">The bank details are as follows:</p>
            <p className="mt-[2rem] legal-para">Bank Name: HDFC Bank </p>
            <p className="legal-para">Bank Account Number: 50200103823257</p>
            <p className="legal-para">IFSC Code: HDFC0001085</p>
            <p className="legal-para">Branch location: Thane Kopri</p>
            <p className="legal-para">Account Type: Current</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentTerms;
